import { EditableTag, TagSize, TagType } from "@visiblethread/react-components";
import {
  OUTLINE_SECTION_STATUS,
  OUTLINE_SECTION_STATUS_LABELS,
} from "constants/proposals";
import { bool, number, oneOf, oneOfType, shape, string } from "prop-types";
import { useSelector } from "react-redux";
import { selectOutlineOwner } from "slices/proposalOutline/selectors";

import useStatusCascade from "./hooks/useStatusCascade";
import styles from "./StatusCell.module.scss";

const STATUS_OPTIONS = [
  {
    value: OUTLINE_SECTION_STATUS.NOT_STARTED,
    label: OUTLINE_SECTION_STATUS_LABELS[OUTLINE_SECTION_STATUS.NOT_STARTED],
    type: TagType.Gray,
  },
  {
    value: OUTLINE_SECTION_STATUS.DRAFTING,
    label: OUTLINE_SECTION_STATUS_LABELS[OUTLINE_SECTION_STATUS.DRAFTING],
    type: TagType.Yellow,
  },
  {
    value: OUTLINE_SECTION_STATUS.IN_REVIEW,
    label: OUTLINE_SECTION_STATUS_LABELS[OUTLINE_SECTION_STATUS.IN_REVIEW],
    type: TagType.Blue,
  },
  {
    value: OUTLINE_SECTION_STATUS.COMPLETE,
    label: OUTLINE_SECTION_STATUS_LABELS[OUTLINE_SECTION_STATUS.COMPLETE],
    type: TagType.Green,
  },
];

const StatusCell = ({ isArchived = false, row }) => {
  const owner = useSelector(selectOutlineOwner);
  const { id, status } = row.original;

  const { onStatusChange } = useStatusCascade(id);

  const onChange = (value) => {
    if (!owner) {
      return;
    }

    const { ownerType, ownerId } = owner;
    onStatusChange(ownerType, ownerId, value);
  };

  return (
    <EditableTag
      value={status ?? OUTLINE_SECTION_STATUS.NOT_STARTED}
      options={STATUS_OPTIONS}
      onChange={onChange}
      title="Set Status"
      size={TagSize.Small}
      disabled={isArchived}
      className={styles.statusCell__tag}
    />
  );
};

StatusCell.propTypes = {
  isArchived: bool,
  row: shape({
    original: shape({
      id: oneOfType([number, string]).isRequired,
      status: oneOf(Object.values(OUTLINE_SECTION_STATUS)),
    }).isRequired,
  }).isRequired,
};

export default StatusCell;
